import { getFetch, postFetch, postFetchWithBody, postFetchWithToken } from "../../utils/fetch";

async function storePush(form) {
  if (form.get("title") === "" || form.get("message") === "") {
    return {
      status: "error",
      message: "عنوان یا پیام اجباری میباشد!",
    };
  }
  const res = await postFetchWithToken("/send-notification", form);
  if (res.status !== "error") {
    if (res.code === "407") {
      return {
        status: "error",
        message: "نام کاربری از قبل برای کاربر دیگر ثبت شده!",
      };
    }
    return {
      status: "success",
      message: "کاربر با موفقیت ایجاد شد",
    };
  } else {
    return {
      status: res.status,
      message: res.message,
    };
  }
}

export { storePush };
